import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { Link } from "react-router-dom";

const initialForm = { name: "", email: "", company: "", phone: "", interest: "", message: "" };

export default function CrovianContact() {
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  const handleChange = ({ target: { name, value } }) => {
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus({ type: "", message: "" });
    setLoading(true);

    try {
      await addDoc(collection(db, "contact_messages"), {
        name: form.name.trim(),
        email: form.email.trim(),
        company: form.company.trim(),
        phone: form.phone.trim(),
        subject: form.interest,
        message: form.message.trim(),
        createdAt: serverTimestamp(),
        source: "crovian-website",
      });
      setForm(initialForm);
      setStatus({ type: "success", message: "Thank you. Your message has been received." });
    } catch (error) {
      console.error("Contact submission failed:", error);
      setStatus({ type: "error", message: "We couldn't send your message. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="contact-page">
      <Helmet>
        <title>Contact — Crovian Technologies</title>
        <meta name="description" content="Start a conversation with Crovian about software engineering, AI, digital products or technology operations." />
        <link rel="canonical" href="https://croviantech.com/contact" />
      </Helmet>

      <section className="contact-hero section-pad">
        <p className="eyebrow">Contact / Crovian</p>
        <h1>LET'S BUILD<br />WHAT COMES NEXT.</h1>
        <p>Tell us what you are building, improving or rethinking. We will respond with a clear next step.</p>
      </section>

      <section className="contact-layout section-pad">
        <aside className="contact-details">
          <div>
            <p className="contact-label">General enquiries</p>
            <a href="mailto:hello@croviantech.com">hello@croviantech.com</a>
          </div>
          <div>
            <p className="contact-label">Location</p>
            <p>Jaipur, Rajasthan<br />India</p>
          </div>
          <div>
            <p className="contact-label">Business areas</p>
            <p>Software Engineering<br />Artificial Intelligence<br />Digital Products<br />Technology Operations</p>
          </div>
          <div>
            <p className="contact-label">Detailed requirements</p>
            <Link to="/project-brief">Share a project brief →</Link>
          </div>
        </aside>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="field-row">
            <label>Full name<input name="name" value={form.name} onChange={handleChange} required autoComplete="name" /></label>
            <label>Work email<input name="email" type="email" value={form.email} onChange={handleChange} required autoComplete="email" /></label>
          </div>
          <div className="field-row">
            <label>Company<input name="company" value={form.company} onChange={handleChange} autoComplete="organization" /></label>
            <label>Phone<input name="phone" value={form.phone} onChange={handleChange} autoComplete="tel" /></label>
          </div>
          <label>
            Area of interest
            <select name="interest" value={form.interest} onChange={handleChange} required>
              <option value="" disabled>Select an area</option>
              <option>Software Engineering</option>
              <option>Artificial Intelligence</option>
              <option>Digital Products</option>
              <option>Technology Operations</option>
              <option>KAI LAB</option>
            </select>
          </label>
          <label>Tell us about the opportunity<textarea name="message" rows="6" value={form.message} onChange={handleChange} required /></label>

          {status.message && <p className={`form-status form-status--${status.type}`} role="status">{status.message}</p>}
          <button className="submit-button" type="submit" disabled={loading}>
            {loading ? "Sending…" : "Send enquiry"}<span aria-hidden="true">→</span>
          </button>
          <p className="form-note">Your information is used only to respond to this enquiry.</p>
        </form>
      </section>
    </main>
  );
}
